<script setup>
import { computed } from 'vue';
import CabColorSection from '@/components/configuratorSections/CabColorSection';
import ConfigurationRadioSelection from '@/components/ConfigurationRadioSelection';
import '@/styles/configurator-section.css';

const emit = defineEmits(['select']);

const props = defineProps({
  cabColour: {
    type: Object,
    default: null,
  },
  exterior: {
    type: Array,
    default: () => {
      return [];
    },
  },
  images: {
    type: Object,
    default: null,
  },
  showCabColourInformation: {
    type: Boolean,
    default: false,
  },
});

import { useMainStore } from '@/store/index.js';

const store = useMainStore();

const exteriorStyling = computed(() => props.exterior?.find(x => x.id === 'exteriorStyling'));
const lighting = computed(() => props.exterior?.find(x => x.id === 'lighting'));
const cabHeight = computed(() => props.exterior?.find(x => x.id === 'cabHeight'));

</script>
<template>
  <section
    id="exterior"
    class="configurator-section"
  >
    <h2>{{ $i18n('exteriorHeaderTitle') }}</h2>
    <CabColorSection
      :items="props.cabColour"
      :front-image="props.images?.view"
      :show-as-subheader="true"
      :show-information="props.showCabColourInformation"
      @select="emit('select', $event, 'cabColour')"
    />
    <ConfigurationRadioSelection
      v-if="exteriorStyling"
      v-model="store.selected.exterior[exteriorStyling.id]"
      :type="exteriorStyling.id"
      :options="exteriorStyling.options"
      :title="exteriorStyling.title"
      @select="emit('select', $event, 'exterior')"
    />
    <ConfigurationRadioSelection
      v-if="lighting"
      v-model="store.selected.exterior[lighting.id]"
      :type="lighting.id"
      :options="lighting.options"
      :title="lighting.title"
      @select="emit('select', $event, 'exterior')"
    />
    <ConfigurationRadioSelection
      v-if="cabHeight"
      v-model="store.selected.exterior[cabHeight.id]"
      :type="cabHeight.id"
      :options="cabHeight.options"
      :title="cabHeight.title"
      @select="emit('select', $event, 'exterior')"
    />
  </section>
</template>
